/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import {
  AbstractSnapshotFormComponent,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
  whenCreateOrEditMode,
} from '@gh/common-shared';
import { STYLES_FLEX_ROW_LAYOUT, STYLES_FLEX_SPACE_BETWEEN } from '@gh/core-ui';
import { JstMasterInfo } from '../../../resources/job-spec-template.model';

@Component({
  selector: 'gh-jst-details-top-form',
  template: require('./jst-details-top-form.component.html'),
  styles: [STYLES_FLEX_ROW_LAYOUT, STYLES_FLEX_SPACE_BETWEEN],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JstDetailsTopFormComponent extends AbstractSnapshotFormComponent<JstMasterInfo> {
  @Input() forRfq: boolean = false;

  @Output() setAsDefault = new EventEmitter<boolean>();

  constructor(private formStateBuilder: FormStateBuilder) {
    super();
  }

  onSetAsDefault(isDefault: boolean): void {
    this.setAsDefault.emit(isDefault);
  }

  protected buildForm(snapshot: FormStateSnapshot<JstMasterInfo>): FormState<JstMasterInfo> {
    return this.formStateBuilder.buildPlain({
      mode: this.mode,
      enabled: whenCreateOrEditMode(),
      snapshot,
      children: {
        name: { required: true },
        memo: void 0,
      },
    });
  }
}
